import { withStyles } from '@material-ui/core/styles';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, setPropTypes, withHandlers } from 'recompose';
import { Checkbox, TableBody, TableCell, TableRow } from '@material-ui/core';
import _ from 'lodash';
import { sendLogin } from '../../auth/Auth';
import DetailTextButton from '../atoms/DetailTextButton';
import EditTextButton from '../atoms/EditTextButton';

const propTypes = {
  classes: PropTypes.object.isRequired
};

const styles = {
  root: {
    display: 'flex'
  },
  tableRow: {
    border: '1px solid #CCCCCC',
    backgroundColor: '#ffffff'
  },
  tableCell: {
    borderBottom: '1px solid #CCCCCC'
  },
  floatRight: {
    textAlign: 'right'
  }
};

const enhance = compose(
  connect(
    state => ({
      shops: state.shops.shops,
      account: state.accounts.account
    }),
    () => ({})
  ),
  setPropTypes(propTypes),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    shops,
    detailOpenAction,
    editOpenAction,
    order,
    orderBy,
    account,
    showCheckboxEditStatus,
    bulkEditStatusCheckedList,
    setBulkEditStatusCheckedList,
    setBulkEditStatusCheckedAll,
    isFukuoka,
    setEditGochiKidFlagCheckedAll,
    gochiKidFlagEditCheckedList,
    setGochiKidFlagEditCheckedList
  }) => {
    useEffect(() => {
      let all = false;
      if (bulkEditStatusCheckedList.length > 0) {
        const shopIds = shops
          .filter(
            shop =>
              shop.status === 'AVAILABLE' || shop.status === 'PRE_AVAILABLE'
          )
          .map(shop => shop.shopId);
        if (shopIds.length > 0) {
          all = shopIds.every(id => bulkEditStatusCheckedList.includes(id));
        }
      }
      setBulkEditStatusCheckedAll(all);
    }, [bulkEditStatusCheckedList, shops]);

    useEffect(() => {
      let all = false;
      if (gochiKidFlagEditCheckedList.length > 0) {
        const shopIds = shops
          .filter(
            shop =>
              shop.status === 'AVAILABLE' || shop.status === 'PRE_AVAILABLE'
          )
          .map(shop => shop.shopId);
        if (shopIds.length > 0) {
          all = shopIds.every(id => gochiKidFlagEditCheckedList.includes(id));
        }
      }
      setEditGochiKidFlagCheckedAll(all);
    }, [gochiKidFlagEditCheckedList, shops]);

    let sortedResult;
    if (orderBy === 'streetAddress') {
      sortedResult = _.orderBy(
        shops,
        ['prefectures', 'city', 'address', 'building'],
        [order, order, order, order]
      );
    } else {
      sortedResult = _.orderBy(shops, orderBy, order);
    }
    return (
      <TableBody>
        {sortedResult.map(shop => {
          let titleStatus = '';
          if (shop.status === 'AVAILABLE') {
            titleStatus = '利用可能';
          } else if (shop.status === 'PRE_AVAILABLE') {
            titleStatus = isFukuoka ? '休止中' : '準備中';
          } else if (shop.status === 'SUSPENDED') {
            titleStatus = isFukuoka ? '利用停止' : '利用停止中';
          } else if (shop.status === 'CLOSED') {
            titleStatus = isFukuoka ? '抹消・取消' : '閉店';
          }

          let titleGochiKidFlag = '';
          if (shop.gochiKidFlag === 0 && shop.gochiKidQrFlag === 0) {
            titleGochiKidFlag = '参加しない';
          } else if (shop.gochiKidFlag === 1 && shop.gochiKidQrFlag === 1) {
            titleGochiKidFlag = '参加する(カード型会員証対応あり)';
          } else if (shop.gochiKidFlag === 1 && shop.gochiKidQrFlag === 0) {
            titleGochiKidFlag = '参加する(カード型会員証対応なし)';
          }
          return (
            <TableRow className={classes.tableRow}>
              <TableCell className={[classes.tableCell, classes.floatRight]}>
                {shop.shopId}
              </TableCell>

              <TableCell className={classes.tableCell}>
                {shop.shopName}
              </TableCell>

              <TableCell className={classes.tableCell}>
                {shop.prefectures}
                {` `}
                {shop.city}
                {` `}
                {shop.address}
                {` `}
                {shop.building}
              </TableCell>

              <TableCell className={classes.tableCell}>{shop.phone}</TableCell>

              <TableCell className={classes.tableCell}>{titleStatus}</TableCell>

              {showCheckboxEditStatus && !isFukuoka && (
                <>
                  <TableCell className={classes.tableCell}>
                    {(shop.status === 'AVAILABLE' ||
                      shop.status === 'PRE_AVAILABLE') && (
                      <Checkbox
                        color="primary"
                        checked={bulkEditStatusCheckedList.includes(
                          shop.shopId
                        )}
                        onChange={event => {
                          if (event.target.checked) {
                            setBulkEditStatusCheckedList([
                              ...bulkEditStatusCheckedList,
                              shop.shopId
                            ]);
                          } else {
                            setBulkEditStatusCheckedList(
                              bulkEditStatusCheckedList.filter(
                                item => item !== shop.shopId
                              )
                            );
                            setBulkEditStatusCheckedAll(false);
                          }
                        }}
                      />
                    )}
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    {(shop.status === 'AVAILABLE' ||
                      shop.status === 'PRE_AVAILABLE') && (
                      <div>{titleGochiKidFlag}</div>
                    )}
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    {(shop.status === 'AVAILABLE' ||
                      shop.status === 'PRE_AVAILABLE') && (
                      <Checkbox
                        color="primary"
                        checked={gochiKidFlagEditCheckedList.includes(
                          shop.shopId
                        )}
                        onChange={event => {
                          if (event.target.checked) {
                            setGochiKidFlagEditCheckedList([
                              ...gochiKidFlagEditCheckedList,
                              shop.shopId
                            ]);
                          } else {
                            setGochiKidFlagEditCheckedList(
                              gochiKidFlagEditCheckedList.filter(
                                item => item !== shop.shopId
                              )
                            );
                            setEditGochiKidFlagCheckedAll(false);
                          }
                        }}
                      />
                    )}
                  </TableCell>
                </>
              )}

              <TableCell className={classes.tableCell}>
                <DetailTextButton
                  params={{ id: shop.shopId }}
                  onClickAction={detailOpenAction}
                />
              </TableCell>

              <TableCell className={classes.tableCell}>
                <EditTextButton
                  disabled={account.groupDisplayLimit === 1}
                  id={shop.shopId}
                  onClickAction={editOpenAction}
                />
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
